import { APITagType } from './invisibly-api.types';

const {
  BrandOffer, Company, CommissionPnl, CommissionReferrals, CommissionReports, CommissionUsers, InsertionOrder, InvoiceGroup, MagazineTitle, PacingView, SuspensionReason, YodleeBankAccount, YodleeToken, Summaries, PulsePollingConfig, OrganizationClients, Panel, TrendsEvents, SurveyGroups,
} = APITagType;

export const ALL_API_TAG_TYPES: APITagType[] = [BrandOffer, Company, CommissionPnl, CommissionReferrals, CommissionReports, CommissionUsers, InsertionOrder, InvoiceGroup, MagazineTitle, PacingView, SuspensionReason, YodleeBankAccount, YodleeToken, Summaries, PulsePollingConfig, OrganizationClients, Panel, TrendsEvents, SurveyGroups];
